import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { DirectiveBinding } from 'vue/types/options'
import { VNode } from 'vue/types/umd'

import axios from 'axios'
import VueAxios from 'vue-axios'

import SolidButton from '@/components/SolidButton.vue'

Vue.component('solid-button', SolidButton)

Vue.use(VueAxios, axios)

Vue.config.productionTip = false

const onScroll = (el: HTMLElement) => {
  const offset = el.offsetHeight * 0.5
  const bottomY = window.scrollY + window.innerHeight - offset

  if (bottomY > el.offsetTop && !el.classList.contains('animatable')) {
    el.classList.add('animatable')
  }
}

Vue.directive('animatable', {
  bind: (el: HTMLElement, binding: DirectiveBinding, node: VNode) => {
    window.addEventListener('scroll', () => {
      onScroll(el)
    })
    onScroll(el)
  },
  unbind: (el: HTMLElement, binding: DirectiveBinding, node: VNode) => {
    el.classList.remove('animatable')
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
